import { render, staticRenderFns } from "./applicationDetail.vue?vue&type=template&id=22b3be93&scoped=true"
import script from "./applicationDetail.vue?vue&type=script&lang=js"
export * from "./applicationDetail.vue?vue&type=script&lang=js"
import style0 from "./applicationDetail.vue?vue&type=style&index=0&id=22b3be93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b3be93",
  null
  
)

export default component.exports